import { useSelector } from 'react-redux';

import { StackNavigator } from './navigation/StackNavigator';
import { RootState } from './store';
function App() {
  const color = useSelector((state: RootState) => state.bgSlice.color);
  
  return (
    <div
      id='app'
      style={{backgroundColor: color}}
    >
      <StackNavigator />
    </div>
  );
}

export default App;
